import React, { useRef, memo, useState, useEffect } from 'react'
import produce from 'immer'
import styled from '@emotion/styled'
import ReactHtmlParser, {
  processNodes,
  convertNodeToElement,
  htmlparser2,
} from 'react-html-parser'

import { motion, AnimatePresence } from 'framer-motion'

import Classnames from 'classnames'

import { Draggable } from 'react-beautiful-dnd'
import {
  RiAddFill,
  RiDragMove2Line,
  RiCloseFill,
  RiCheckFill,
  RiMessage2Line,
} from 'react-icons/ri'

import { useRecoilState, useRecoilValue, useRecoilCallback } from 'recoil'
import { content, content_block } from '@/store/template/content'
import {
  showListDetailModal,
  detailModalContentID,
  detailModalContentBlockID,
  detailModalSectionData,
} from '@/store/onepager/onepager'
import { isBuilder } from '@/store/builder/store'

import ContentEditable from 'react-contenteditable'

function Task({ id, index, contentID, sectionData }) {
  // focused, onInlineAdd

  const [getContent, setContent] = useRecoilState(content_block(id))
  const [getContentParent, setContentParent] = useRecoilState(
    content(contentID)
  )
  const [showDetailModal, setShowDetailModal] = useRecoilState(
    showListDetailModal
  )
  const [detailModalCID, setDetailModalCID] = useRecoilState(
    detailModalContentID
  )
  const [detailModalCBID, setDetailModalCBID] = useRecoilState(
    detailModalContentBlockID
  )
  const [detailSectionData, setDetailSectionData] = useRecoilState(
    detailModalSectionData
  )
  const isBuilderApp = useRecoilValue(isBuilder)
  const [isNotDraggable, setIsNotDraggable] = useState(false)
  const contentEditable = React.createRef()
  const taskText = useRef('')

  const taskRef = React.createRef()

  useEffect(() => {
    if (isBuilderApp) {
      // in builder
    } else {
      if (sectionData.data.readonly == 'true') {
        setIsNotDraggable(true)
      }
    }
  }, [])

  // React.useEffect(() => {
  //   if (focused) {
  //     console.log(focused);
  //     contentEditable.current.focus()
  //   }
  // }, [focused])

  const TaskDiv = styled.div`
    outline: none;
    border-radius: 12px;
    font-weight: 500;
    /* padding: 12px 15px; */
    /* background: #fff; */

    /* border: 1px solid #71809680; */
    /* box-shadow: inset 0 0 0 3px #71809610, 0 1px 3px 0 rgba(0, 0, 0, 0.08), 0 1px 2px 0 rgba(0, 0, 0, 0.06); */
    /* background-color: #a0aec005; */
    color: #2b2f35;

    font-size: 16px;

    &:hover {
      /* background: #71809610; */
      /* box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.08), 0 1px 2px 0 rgba(0, 0, 0, 0.06); */
    }
  `

  const SortHandle = styled.div`
    left: -25px;
    opacity: 0;
  `

  const RemoveHandle = styled.div`
    right: -25px;
    opacity: 0;
  `

  const TaskTick = styled.div`
    border: 2px solid #718096;
    box-shadow: inset 1px 1px 1px rgba(0, 0, 0, 0.05);
    background: #fff;
    height: 25px;
    width: 25px;
    border-radius: 50%;
    position: relative;
    transition: all 0.2s ease;
  `

  const taskTextChange = evt => {
    taskText.current = evt.target.value
  }

  const taskTextBlur = () => {
    const nextState = produce(getContent, draft => {
      draft.text = taskText.current
    })
    setContent(nextState)
  }

  const newTaskEnter = e => {
    if (e.key === 'Enter') {
      e.preventDefault()

      // save current task text
      taskTextBlur()

      const newTask = {
        complete: false,
        text: '',
      }

      const taskId = guidGenerator()

      // push ID to this getContent.blocks
      const nextState = produce(getContentParent, draft => {
        draft.blocks.splice(index + 1, 0, taskId)
      })

      setContentParent(nextState)

      insertContentBlock(taskId, newTask)

      // emit event
      // onInlineAdd(index + 1)
    }
  }

  const insertContentBlock = useRecoilCallback(
    ({ set, newId, newContent }) => {
      return (newId, newContent) => {
        // set and create content
        set(content_block(newId), newContent)
      }
    },
    [content_block]
  )

  const toggleComplete = e => {
    e.stopPropagation()
    const nextState = produce(getContent, draft => {
      draft.complete = !draft.complete
    })
    setContent(nextState)
  }

  const editTask = () => {
    if (isBuilderApp) {
      // in builder
      setShowDetailModal(true)
      setDetailModalCID(contentID)
      setDetailModalCBID(id)
      setDetailSectionData(sectionData)
    } else if (sectionData.data.readonly == 'true') {
      if (getContent.notes) {
        // open modal if extra content
        setShowDetailModal(true)
        setDetailModalCID(contentID)
        setDetailModalCBID(id)
        setDetailSectionData(sectionData)
      }
    } else if (sectionData.data.readonly !== 'true') {
      setShowDetailModal(true)
      setDetailModalCID(contentID)
      setDetailModalCBID(id)
      setDetailSectionData(sectionData)
    }
  }

  const removeTask = () => {
    // remove from content.blocks
    const nextState = produce(getContentParent, draft => {
      const index = draft.blocks.findIndex(task => task === id)
      if (index !== -1) draft.blocks.splice(index, 1)
    })
    setContentParent(nextState)

    // remove from atom family TODO
  }

  function guidGenerator() {
    var S4 = function () {
      return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1)
    }
    return (
      S4() +
      S4() +
      '-' +
      S4() +
      '-' +
      S4() +
      '-' +
      S4() +
      '-' +
      S4() +
      S4() +
      S4()
    )
  }

  return (
    <Draggable
      key={id}
      draggableId={id}
      index={index}
      isDragDisabled={isNotDraggable}
    >
      {(provided, snapshot) => (
        <div
          onClick={editTask}
          key={id}
          ref={provided.innerRef}
          {...provided.draggableProps}
          {...provided.dragHandleProps}
          className={Classnames(
            'mb-2 taskWrapper relative flex items-center cursor-pointer'
          )}
        >
          {/* <motion.div className="mb-2 taskWrapper relative flex items-center" initial="hidden" animate="visible"
            variants={{
              hidden: {
                opacity: 0,
                scale: 0.95
              },
              visible: {
                opacity: 1,
                scale: 1
              },
            }}> */}

          <TaskDiv
            className={Classnames('flex mb-1 ', 'flex-grow', {
              taskIsComplete: getContent.complete,
              listItemColorGreen: getContent.color == 'green',
              listItemColorBlue: getContent.color == 'blue',
              listItemColorRed: getContent.color == 'red',
              listItemColorPurple: getContent.color == 'purple',
              listItemColorPink: getContent.color == 'pink',
              listItemColorIndigo: getContent.color == 'indigo',
              listItemColorTeal: getContent.color == 'teal',
              listItemColorOrange: getContent.color == 'orange',
              listItemColorYellow: getContent.color == 'yellow',
              listItemColorGray: getContent.color == 'gray',
            })}
          >
            <TaskTick
              onClick={toggleComplete}
              className="taskTickBox mr-3 mt-0.5  cursor-pointer flex-shrink-0 flex items-center flex-col justify-center"
            >
              {getContent.complete && <RiCheckFill />}
            </TaskTick>

            <div
              className={Classnames('TaskItemText  flex-grow outline-none', {
                'cursor-pointer':
                  (getContent.notes && sectionData.data.readonly == 'true') ||
                  sectionData.data.readonly !== 'true' ||
                  isBuilderApp,
              })}
            >
              <div>{ReactHtmlParser(getContent.text)}</div>
              {getContent.desc && (
                <div className="text-xs opacity-75">
                  {ReactHtmlParser(getContent.desc)}
                </div>
              )}
            </div>

            {getContent.notes && (
              <div className="absolute cursor-pointer hover:opacity-50 top-0 right-0 mr-3 mt-3">
                <RiMessage2Line />
              </div>
            )}

            {/* <div ref={ref} className={'TaskItemText flex-grow outline-none'} contentEditable={true} onChange={taskTextChange} onBlur={taskTextBlur} onKeyDown={newTaskEnter} placeholder="..." >{getContent.text}</div> */}

            {/* <ContentEditable className={'TaskItemText flex-grow outline-none'} html={getContent.text} innerRef={contentEditable} onChange={taskTextChange} onBlur={taskTextBlur} onKeyDown={newTaskEnter} placeholder="..." /> */}
          </TaskDiv>

          {/* </motion.div> */}
        </div>
      )}
    </Draggable>
  )
}

// export default memo(forwardRef(Task));
export default memo(Task)
